import { gql } from "@apollo/client";
import { Heading, Spinner } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../auth";
import { TemplateEditForm } from "../../components/TemplateEditForm";
import { useTemplateEdit_GetTemplateQuery } from "../../graphql/generated/apollo";
import { useShopContext } from "../../shop";

gql`
query TemplateEdit_GetTemplate($id: uuid!) {
  templates_by_pk(id: $id) {
    id
    name
    is_default
    shop_id
    data
  }
}
`;

export function TemplateEdit() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuthContext();
  const { currentShopId, isLoading: shopLoading } = useShopContext();

  const { data, loading, error } = useTemplateEdit_GetTemplateQuery({
    variables: {
      id: id ?? "",
    },
    skip: !id || !user || !currentShopId,
  });

  if (authLoading || shopLoading || loading) return <Spinner />;
  if (error) return <div>エラーが発生しました: {error.message}</div>;
  if (!data?.templates_by_pk) return <div>テンプレートが見つかりません</div>;

  const handleSave = async () => {
    navigate("/settings/templates");
  };

  const handleCancel = () => {
    navigate("/settings/templates");
  };

  return (
    <>
      <Heading fontSize="lg" textAlign="left" py={2}>
        テンプレート編集
      </Heading>
      <TemplateEditForm template={data.templates_by_pk} onSave={handleSave} onCancel={handleCancel} />
    </>
  );
}
